module.exports = __webpack_public_path__ + "media/fuel_types/pb98-c9d4b3e7.png";